import { Link, NavLink } from '@remix-run/react'
import { iseLogoFull } from '#app/routes/_marketing+/logos/logos.ts'
import { cn } from '#app/utils/misc.tsx'
import { useOptionalUser } from '#app/utils/user.ts'
import { USPBanner } from './usp-banner.tsx'
import { UserDropdown } from './user-dropdown.tsx'
import { Divider } from '@intersport-digital/react'
import { Icon } from '../icon.tsx'
import { ISEV2Drawer } from '#app/components/Drawer/ISEV2Drawer.tsx'
import React from 'react'
import { Button } from '../button.tsx'

const Header: React.FC<{}> = () => {
	const user = useOptionalUser()
	const [drawerOpen, setDrawerOpen] = React.useState(false)

	return (
		<>
			<ISEV2Drawer opened={drawerOpen} onClose={() => setDrawerOpen(false)} />
			<USPBanner />
			<header className="container flex flex-col py-6">
				<nav className="flex items-center justify-center gap-5 md:justify-start">
					<Link to="/" className="text-decoration-none flex flex-col pb-2">
						<img
							src={iseLogoFull}
							alt="INTERSPORT Logo"
							className="h-7 md:h-8"
						/>
					</Link>

					<NavLink
						to="butiker"
						className={({ isActive }) =>
							cn('nav-link !hidden md:!block', isActive && 'nav-link--active')
						}
					>
						Butiker
					</NavLink>
					<div className="ml-auto flex flex-row items-end gap-4">
						<Button onClick={() => setDrawerOpen(!drawerOpen)} variant="ghost">
							<Icon
								name="hamburger"
								className="icon-container"
								strokeWidth={2}
							/>
						</Button>
						<div className="my-auto ml-auto flex !hidden flex-col">
							{user ? (
								<UserDropdown />
							) : (
								<Link to="/login">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="25"
										height="24"
										fill="none"
										className="icon-container icon-account"
										viewBox="0 0 25 24"
										data-testid="svg-icon"
									>
										<path
											stroke="currentColor"
											strokeWidth="2"
											d="M12.5 4a4 4 0 00-2.585 7.053c.338.286.585.685.585 1.129 0 .245-.067.492-.25.656-.997.89-3.674 1.624-4.644 2.11A2 2 0 004.5 16.735V19h16v-2.264a2 2 0 00-1.106-1.789c-.97-.485-3.647-1.22-4.644-2.11-.183-.163-.25-.41-.25-.655 0-.444.247-.843.585-1.13A4 4 0 0012.5 4z"
										></path>
									</svg>
								</Link>
							)}
						</div>
					</div>
				</nav>
				<Divider size="bold" />
			</header>
		</>
	)
}

export { Header }
